module.exports = __webpack_public_path__ + "static/media/Rectangle.901a151c.png";